// extracted by css-extract-rspack-plugin
export default {"icon-and-productype":"d16zxj","iconAndProductype":"d16zxj","product-type":"Umhodz","productType":"Umhodz"};